export enum TipoProductoEnum {
    PRESENCIAL = 'PRESENCIAL',
    SERVICIO_WEB = 'SERVICIO_WEB'
}
